export default class PaymentStatusPoller {
  constructor ({
    fetchStatus,
    schedule = (callback, delay) => setTimeout(callback, delay),
    cancel = timeout => clearTimeout(timeout),
    interval = 10000,
    maxAttempts = 30,
    onStatus,
    onComplete,
    onFailure,
    onReview
  }) {
    this.fetchStatus = fetchStatus
    this.schedule = schedule
    this.cancel = cancel
    this.interval = interval
    this.maxAttempts = maxAttempts
    this.onStatus = onStatus
    this.onComplete = onComplete
    this.onFailure = onFailure
    this.onReview = onReview || onStatus
    this.attempts = 0
    this.inFlight = false
    this.stopped = false
  }

  start () {
    if (this.inFlight || this.stopped) return
    this.poll()
  }

  async poll () {
    if (this.inFlight || this.stopped) return

    this.inFlight = true
    this.attempts += 1

    try {
      const status = await this.fetchStatus()

      if (status.completed) {
        this.stop()
        this.onComplete(status)
      } else if (status.needs_review || status.status === 'needs_review') {
        this.stop()
        this.onReview(status)
      } else if (status.final || ['failed', 'cancelled'].includes(status.status)) {
        this.stop()
        this.onFailure(status)
      } else {
        this.onStatus(status)
        this.scheduleNext()
      }
    } catch (error) {
      const failure = { status: 'error', completed: false, error }
      if (this.attempts >= this.maxAttempts) {
        this.stop()
        this.onFailure(failure)
      } else {
        this.onStatus({ status: 'retrying', completed: false })
        this.scheduleNext()
      }
    } finally {
      this.inFlight = false
    }
  }

  scheduleNext () {
    if (this.attempts >= this.maxAttempts) {
      this.stop()
      this.onFailure({ status: 'error', completed: false })
      return
    }

    this.timeout = this.schedule(() => this.poll(), this.interval)
  }

  stop () {
    this.stopped = true
    if (this.timeout) this.cancel(this.timeout)
  }
}
